namespace RecordShield.Modules.Workspace {
    export interface ChangeStatusBulkActionRequest extends Serenity.ServiceRequest {
        SerialIDs?: number[];
    }
}
